// removed by extract-text-webpack-plugin
module.exports = {"down":"speed-trend-icon-down--ki_P2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SpeedTrendIcon/speed-trend-icon.scss
// module id = uHvf
// module chunks = 4